<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border: 1px solid #e2e2e2;
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          display: flex;
          align-items: center;
          padding: 10px 20px;
        "
      >
        <li style="font-size: 13px; flex: 1">{{ state.model.name }}</li>
      </ul>
      <ul style="padding: 0 10px">
        <el-descriptions
          :column="4"
          border
          style="overflow-x: auto; margin-top: 10px"
          class="desc-label-nowrap"
        >
          <el-descriptions-item label="名称" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.name }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="状态" label-align="right">
            <div style="min-width: 200px">
              <c_status
                v-if="
                  state.model.status != null && state.model.status != undefined
                "
                arr-name="salarypayment_status"
                :value="state.model?.status"
              ></c_status>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="所属客户" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.customer_name || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="扣缴义务人" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.withholding_agent_name || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="薪资所属期" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.month || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="约定发薪日期" label-align="right">
            <div style="min-width: 200px">
              {{ state.model.pay_date || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="已发放金额" label-align="right">
            <div style="min-width: 200px">
              {{ $priceFormat(state.model.payed_money) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="本次发放金额" label-align="right">
            <div style="min-width: 200px">
              {{ $priceFormat(state.model.money) }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="本次发放数量" label-align="right">
            <div style="min-width: 200px">
              {{ $numberFormat(state.model.employee_num) }}
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </ul>
      <ul
        style="
          flex: 1;
          padding: 0 20px;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        "
      >
        <el-tabs
          v-model="state.activeName"
          class="detail-tabs"
          @tab-click="handleClick"
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            padding: 10px 0;
          "
        >
          <el-tab-pane label="工资表明细" name="record">
            <c_Record
              :id="props.data?.id"
              :model="state.model"
              v-if="state.activeName == 'record'"
            ></c_Record>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="log">
            <c_Log
              :id="props.data?.id"
              v-if="state.activeName == 'log'"
            ></c_Log>
          </el-tab-pane>
        </el-tabs>
      </ul>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="编辑员工"
      @close="state.showEdit = false"
    >
      <c_EmployeeEdit
        @close="
          state.showEdit = false;
          onLoad();
        "
        :model="state.model"
      ></c_EmployeeEdit>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { salarypayment_detail } from "@/http/salarypayment";

import c_Record from "./Record.vue";
import c_Log from "./Log.vue";
export default {
  components: {
    c_Record,
    c_Log,
  },
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      model: {},
      activeName: "record",
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      salarypayment_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    };

    return { state, props };
  },
};
</script>
<style scoped></style>
